const GeneralIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4802_12579)">
        <path
          d="M16.875 16.2547H1.77185V1.12344C1.77185 0.785937 1.4906 0.476562 1.12498 0.476562C0.759351 0.476562 0.506226 0.785937 0.506226 1.12344V16.3391C0.506226 16.9859 1.0406 17.5203 1.68748 17.5203H16.875C17.2125 17.5203 17.5219 17.2391 17.5219 16.8734C17.5219 16.5078 17.2125 16.2547 16.875 16.2547Z"
          fill="#637381"
        />
        <path
          d="M16.5938 6.21484H13.3031C12.9656 6.21484 12.6562 6.49609 12.6562 6.86172C12.6562 7.22734 12.9375 7.50859 13.3031 7.50859H15.2156L13.725 8.80234H10.0406C9.84375 8.80234 9.64688 8.88672 9.53438 9.05547L7.5375 11.6711H4.58437C4.24687 11.6711 3.9375 11.9523 3.9375 12.318C3.9375 12.6836 4.21875 12.9648 4.58437 12.9648H7.84687C8.04375 12.9648 8.24063 12.8805 8.35313 12.7117L10.35 10.0961H13.9781C14.1188 10.0961 14.2875 10.0398 14.4 9.92734L16.2562 8.29609V10.4617C16.2562 10.7992 16.5375 11.1086 16.9031 11.1086C17.2687 11.1086 17.55 10.8273 17.55 10.4617V7.11484C17.5219 6.63672 17.1 6.21484 16.5938 6.21484Z"
          fill="#637381"
        />
      </g>
      <defs>
        <clipPath id="clip0_4802_12579">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GeneralIcon;
